import React from 'react'
import { Container } from './Item'
import styled from '../../styled'

/**
 * ItemIcon component
 * author: soojin.oh
 */

// type definitions
type ItemIconImpl = React.FunctionComponent<{
  title: string
  id: string
  icon: string
  onClick: (id: string) => void
}>

// styled components
const Title = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
`
const Icon = styled.img`
  width: 2.4rem;
  min-width: 2.4rem;
  height: 2.4rem;
  margin-right: 1.6rem;
`
const Text = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  line-height: 1.9rem;
  color: ${({ theme }) => theme.color.gray900};
`

// ItemIcon component
const ItemIcon: ItemIconImpl = function ({ title, id, onClick, icon }) {
  return (
    <Container onClick={() => onClick(id)}>
      <Title>
        <Icon src={icon} />
        <Text>{title}</Text>
      </Title>
    </Container>
  )
}

export default ItemIcon
